(function(window, mL, mL_errors, mL_events, mL_config) {
    "use strict";

    var key = 'modernio';

    function safe_start() {
        if (mL_config.do_not_track || !mL_config.tags || !mL_config.tags.mio) return;

        var tag;
        var tag_src = 'https://cdata.mpio.io/js/E3F2946ED20AA6.js';

        mL.mio = mL.mio || {};


        mL_events.subscribe('page', function(msg, data) {
            if (mL_config.AUDIT) console.log('pubsub ' + key + ' - ' + msg, data);
            if (!tag) return;
            tag.src = tag_src + '?ts=' + new Date().getTime();
        });

        mL_events.subscribe('order.pageview', function(msg, data) {
            if (data.url && data.url.indexOf('confirmation') !== -1) return;
            if (!tag) return;
            tag.src = tag_src + '?ts=' + new Date().getTime();


            if (mL_config.DEBUG) console.log(key + ' - ' + msg, { data: data });
        });

        mL_events.subscribe('order.confirmation', function(msg, data) {
            if("undefined" !== typeof MGX_DATA) MGX_DATA.push({Label:'CheckoutComplete'});        

            if (!tag) return;
            tag.src = tag_src + '?ts=' + new Date().getTime();

            if (mL_config.DEBUG) console.log(key + ' - ' + msg, { data: data });
        });

        mL.mio.init = function() {
            if (mL.mio.is_init || !mL.add_tracker) return false;

            tag = document.createElement('script');
            tag.id = key;
            tag.type = 'text/javascript';
            tag.async = true;
            tag.src = tag_src;
            var s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(tag, s);

            mL.mio.is_init = true;

            if (mL_config.DEBUG) console.log(key + ' - plugin loaded');
        };

    }

    try {
        safe_start();
    } catch (err) {
        mL_errors(new Error('safe_start failed - ' + key.toUpperCase()));
        mL_errors(err);
    }


}(window, window.mL, window.mL_errors, window.mL_events, window.mL_config));